import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
  user?: CustomerPortalUser;
}

const initialState: AuthState = {
  user: undefined
};

export const authReducerName = 'auth';

const authSlice = createSlice({
  name: authReducerName,
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    }
  }
});

export const authReducer = authSlice.reducer;
export const { setUser } = authSlice.actions;
